import { Component, inject, OnInit } from '@angular/core';
import { EventsService } from '../../services/events.service';
import { Event } from '../../models/event.model';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-events',
  imports: [DatePipe, RouterLink, FormsModule],
  templateUrl: './events.component.html',
  styles: `
    .card {
      --bs-card-border-radius: 0;
      --bs-card-inner-border-radius: 0;
    }
  `
})
export class EventsComponent implements OnInit {
  events: Event[] = [];
  loading = true;
  params = {
    title: '',
    date: ''
  };
  timeout: any;

  private eventsService = inject(EventsService);

  ngOnInit() {
    this.getEvents();
  }

  getEvents() {
    this.loading = true;
    this.events = [];

    this.eventsService.getAll(this.params).subscribe({
      next: (res) => {
        this.loading = false;
        this.events = res.data.records;
      },
      error: (err) => {
        this.loading = false;
        console.log(err);
      }
    });
  }

  handleSearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.getEvents(), 600);
  }
}
